export const REPORTDETAILSDATA = 'REPORTDETAILSDATA'
export const REPORTDETAILSSUMMARY = 'REPORTDETAILSSUMMARY'
export const FETCH = 'FETCH'
export const FETCH2 = 'FETCH2'
export const CONTACTDATAFETCH = 'CONTACTDATAFETCH'
export const SETSCHEDULEDATA = 'SETSCHEDULEDATA'
export const SETDBSCHEDULEDATA = 'SETDBSCHEDULEDATA'
